import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PaymentMethodsRequestService } from '@cargos/sprintpay-services';
import { take } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-lib-request-finance-button',
    standalone: true,
    templateUrl: './request-finance-button.html',
    imports: [CommonModule, MatIconModule, MatTooltipModule, MatButtonModule],
})
export class RequestFinanceButtonComponent {
    public sprintPayFlexButtonDisabled: boolean = false;

    @Input() sprintPayFlexButtonText: string = 'Request to Finance';

    constructor(private paymentMethodsService: PaymentMethodsRequestService) {}

    sendRequestFinanceSupport(): void {
        this.paymentMethodsService
            .customerFinanceSalesSupport()
            .pipe(take(1))
            .subscribe({
                next: () => {
                    this.sprintPayFlexButtonText = 'Your Request Has Been Submitted';
                    this.sprintPayFlexButtonDisabled = true;
                    Swal.fire({
                        title: 'Thank you for your interest in SprintPay Flex',
                        text: 'We have received your request and will follow up within 1 business day.',
                        padding: '16px',
                        icon: 'success',
                        timer: 5000,
                    });
                },
                error: (err: unknown) => {
                    Swal.fire({
                        html: 'Error processing your request. Please try again.',
                        icon: 'error',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        allowOutsideClick: false,
                    });
                },
            });
    }
}
